import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const powerMaxConsumptionDailyReducer = (state = {
    LineDiagrammMonatsLeistungUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_LineDiagrammMonatsLeistung_powerMaxConsumptionDailyReducer":
            return { ...state, LineDiagrammMonatsLeistungUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, LineDiagrammMonatsLeistungUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default powerMaxConsumptionDailyReducer;
